import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { HEADLINE } from "@/lib/typography";
import { cn } from "@/lib/utils";

interface CalendarDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onGoogleCalendar: () => void;
  onAppleCalendar: () => void;
}

function CalendarButtons({ onGoogleCalendar, onAppleCalendar }: Pick<CalendarDrawerProps, "onGoogleCalendar" | "onAppleCalendar">) {
  return (
    <div className="flex flex-col gap-3 pt-4 pb-2">
      <Button size="modal" variant="secondary" onClick={onGoogleCalendar}>
        Google Calendar
      </Button>
      <Button size="modal" variant="secondary" onClick={onAppleCalendar}>
        Apple Calendar
      </Button>
    </div>
  );
}

export function CalendarDrawer({ open, onOpenChange, onGoogleCalendar, onAppleCalendar }: CalendarDrawerProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent>
          <DrawerTitle className={cn(HEADLINE, "text-center")}>Add event with...</DrawerTitle>
          <CalendarButtons onGoogleCalendar={onGoogleCalendar} onAppleCalendar={onAppleCalendar} />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xs">
        <DialogTitle className={cn(HEADLINE, "text-center")}>Add event with...</DialogTitle>
        <CalendarButtons onGoogleCalendar={onGoogleCalendar} onAppleCalendar={onAppleCalendar} />
      </DialogContent>
    </Dialog>
  );
}
